import {IconWrapperIconProps} from "app/Interface/Component/Icons"
import IconWrapper from "app/WebView/Component/icons/icon"
import React from "react"
import GridView from "static/icons/grid_view_black_24dp.svg"

const ModuleDashboardIcon = (props: IconWrapperIconProps) => {
  const name = "moduleDashboard"
  return (
    <IconWrapper name={name} {...props}>
      <GridView/>
    </IconWrapper>
  )
}

export default ModuleDashboardIcon
